/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RoomServiceTier = {
    Club: 'Club',
    Concierge: 'Concierge',
    Exec: 'Exec',
    Executive: 'Executive',
    Gold: 'Gold',
    Luxe: 'Luxe',
    Me: 'ME',
    Penthouse: 'Penthouse',
    Platinum: 'Platinum',
    Premier: 'Premier',
    Premium: 'Premium',
    Red: 'Red',
    Royal: 'Royal',
    Royalty: 'Royalty',
    Signature: 'Signature',
    Standard: 'Standard',
    Superior: 'Superior',
    Vip: 'VIP'
} as const;
export type RoomServiceTier = typeof RoomServiceTier[keyof typeof RoomServiceTier];


export function instanceOfRoomServiceTier(value: any): boolean {
    for (const key in RoomServiceTier) {
        if (Object.prototype.hasOwnProperty.call(RoomServiceTier, key)) {
            if (RoomServiceTier[key as keyof typeof RoomServiceTier] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RoomServiceTierFromJSON(json: any): RoomServiceTier {
    return RoomServiceTierFromJSONTyped(json, false);
}

export function RoomServiceTierFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomServiceTier {
    return json as RoomServiceTier;
}

export function RoomServiceTierToJSON(value?: RoomServiceTier | null): any {
    return value as any;
}

export function RoomServiceTierToJSONTyped(value: any, ignoreDiscriminator: boolean): RoomServiceTier {
    return value as RoomServiceTier;
}

